import { PureComponent } from 'react'
import styled from 'glamorous'
import { filter, map } from 'lodash'
import PerfectScrollbar from 'react-perfect-scrollbar'
import { withRouter } from 'react-router-dom'
import { compose, graphql } from 'react-apollo'

import { $, getError } from 'utils'
import { withConsumer } from 'store'
import { Button, Icon, InfoRow, Loader, HeaderRow, Date, ListItem, ImagePure, Tooltip } from 'components'
import { AddListPanel, AddPersonsPanel, MatchPanel, VerifyPanel } from 'components/panels'
import { DESCRIPTOR, AttachListToDescriptor, AttachDescriptorToPerson,
  DetachListFromDescriptor, DetachDescriptorFromPerson } from 'queries'

const Container = styled.div({
  position: 'relative',
  width: '100%',
  height: '100%',
  overflow: 'hidden'
})

const DetailsInfoContainer = styled.div({
  position: 'absolute',
  width: '100%',
  height: '100%',
}, 'detailsInfoContainer')

const DetailsInfoContainerInner = styled(PerfectScrollbar)({
  position: 'relative',
}, 'scrollableContainer')

const Block = styled.div({
  padding: 30,
  borderBottom: '1px solid var(--borderColor)',
})

const InfoButtons = styled.div({
  width: '100%',
  display: 'flex',
  marginTop: 20,
})

const PanelContainer = styled.div({
  position: 'absolute',
  left: 0,
  width: '100%',
  height: '100%',
  overflow: 'hidden',
  zIndex: 1,
}, 'PanelContainer')

const DetailsInfo = ({
  openBottomView,
  setAddMode,
  descriptor: { uuid, portrait, lastUpdate, lists, person },
  history }) =>
  $(DetailsInfoContainer,
    $(DetailsInfoContainerInner,
      $(Block,
        $(ImagePure, { src: portrait }),
        $('br'),
        // $(HeaderRow, { label: 'Face info' }),
        $(InfoRow, { name: 'ID:', value: uuid }),
        $(InfoRow, { name: 'Last update:', value: $(Date, { value: lastUpdate }) }),
        // $(InfoRow, { name: 'Gender:', value: '98% Female (fake)' }),
        // $(InfoRow, { name: 'Age:', value: '23 (fake)' }),
        $(InfoButtons,
          $(Button, {
            bgColor: 'var(--green)',
            width: '75px',
            primary: true,
            onClick: () => openBottomView('match')
          }, 'Match'),
          $(Button, {
            bgColor: 'var(--blue)',
            width: '75px',
            primary: true,
            onClick: () => openBottomView('identify'),
            style: {marginLeft: 10},
          }, 'Ident'),
          $(Button, {
            bgColor: 'var(--darkViolet)',
            width: '75px',
            primary: true,
            onClick: () => openBottomView('verify'),
            style: {marginLeft: 10},
          }, 'Verify'),
        )
      ),
      $(Block,
        $(HeaderRow, { label: 'Lists', count: lists.length },
          $(Tooltip, { tip: 'Add lists' },
            $(Icon, { type: 'add', onClick: () => setAddMode('lists') })
          )
        ),
        map(lists, (list, i) =>
          $(ListItem, {
            key: i,
            last: i === lists.length - 1,
            name: list.listData,
            value: list.uuid,
            isHoverable: true,
            onClick: () => history.push({ pathname: `/list/faces/${list.uuid}` }),
          })
        )
      ),
      $(Block,
        $(HeaderRow, { label: 'Person' },
          $(Tooltip, { tip: 'Add person' },
            $(Icon, { type: 'add', onClick: () => setAddMode('persons') })
          )
        ),
        person &&
        $(ListItem, {
          name: person.userData,
          value: person.uuid,
          last: true,
          isHoverable: true,
          onClick: () => history.push({ pathname: `/persons/${person.uuid}` }),
        })
      )
    )
  )

export class DetailsPage extends PureComponent {

  state = {
    bottomView: undefined,
    addMode: undefined,
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.match.params.id !== nextProps.match.params.id) {
      this.setState({ bottomView: undefined, addMode: undefined })
    }
  }

  setAddMode = (mode) => this.setState({ addMode: mode })

  showBottomPanel = (bottomView) => {
    this.setState({ bottomView })
  }

  detachDescriptorFromPerson = (person) => {
    return this.props.detachDescriptorFromPerson({
      variables: {
        personUUID: person.uuid,
        descriptorUUIDs: [this.props.data.descriptor.uuid],
      },
      update: (proxy, { data: { detachDescriptorFromPerson } }) => {
        if (detachDescriptorFromPerson.ok) {
          const variables = { uuid: this.props.data.descriptor.uuid }
          const data = proxy.readQuery({ query: DESCRIPTOR, variables })
          data.descriptor.person = null
          proxy.writeQuery({ query: DESCRIPTOR, data, variables })
        }
      }
    })
      .catch(error => this.props.setErrorMessage(getError(error)))
  }

  attachDescriptorToPerson = (person) => {
    return this.props.attachDescriptorToPerson({
      variables: {
        personUUID: person.uuid,
        descriptorUUIDs: [this.props.data.descriptor.uuid],
      },
      update: (proxy, { data: { attachDescriptorToPerson } }) => {
        if (attachDescriptorToPerson.ok) {
          const variables = { uuid: this.props.data.descriptor.uuid }
          const data = proxy.readQuery({ query: DESCRIPTOR, variables })
          data.descriptor.person = {
            uuid: person.uuid,
            userData: person.userData,
            portrait: `/portrait/${this.props.data.descriptor.uuid}`,
            __typename: "Person"
          }
          proxy.writeQuery({ query: DESCRIPTOR, data, variables })
        }
      }
    })
      .catch(error => this.props.setErrorMessage(getError(error)))
  }

  handleSubmitPerson = async ([newPerson]) => {
    const oldPerson = this.props.data.descriptor.person
    const detach = oldPerson != null && (!newPerson || (newPerson.uuid !== oldPerson.uuid)) ? oldPerson : null
    const attach = newPerson && (oldPerson == null || (newPerson.uuid !== oldPerson.uuid)) ? newPerson : null
    if (detach) {
      await this.detachDescriptorFromPerson(detach)
    }
    if (attach) {
      this.attachDescriptorToPerson(attach)
    }
  }


  detachListFromDescriptor = (items) => {
    return this.props.detachListFromDescriptor({
      variables: {
        descriptorUUID: this.props.data.descriptor.uuid,
        listUUIDs: map(items, item => item.uuid),
      },
      update: (proxy, { data: { detachListFromDescriptor } }) => {
        if (detachListFromDescriptor.ok) {
          const variables = { uuid: this.props.data.descriptor.uuid }
          const data = proxy.readQuery({ query: DESCRIPTOR, variables })
          data.descriptor.lists = filter(data.descriptor.lists, list =>
            !items.some(item => item.uuid === list.uuid))
          proxy.writeQuery({ query: DESCRIPTOR, data, variables })
        }
      }
    })
      .catch(error => this.props.setErrorMessage(getError(error)))
  }

  attachListToDescriptor = (items) => {
    return this.props.attachListToDescriptor({
      variables: {
        descriptorUUID: this.props.data.descriptor.uuid,
        listUUIDs: map(items, item => item.uuid),
      },
      update: (proxy, { data: { attachListToDescriptor } }) => {
        if (attachListToDescriptor.ok) {
          const variables = { uuid: this.props.data.descriptor.uuid }
          const data = proxy.readQuery({ query: DESCRIPTOR, variables })
          data.descriptor.lists = [...map(items, item => ({
            uuid: item.uuid,
            listData: item.listData,
            __typename: "List"
          })), ...(data.descriptor.lists || [])]
          proxy.writeQuery({ query: DESCRIPTOR, data, variables })
        }
      }
    })
      .catch(error => this.props.setErrorMessage(getError(error)))
  }

  handleSubmitLists = async (newItems) => {
    const oldItems = this.props.data.descriptor.lists
    const detach = filter(oldItems, old =>
      !newItems.some(item => item.uuid === old.uuid))
    const attach = filter(newItems, item =>
      !oldItems.some(old => old.uuid === item.uuid))
    if (detach.length > 0) {
      await this.detachListFromDescriptor(detach)
    }
    if (attach.length > 0) {
      this.attachListToDescriptor(attach)
    }
  }

  render() {
    const { bottomView, addMode } = this.state
    const { data: { loading, descriptor } } = this.props
    if (loading && !descriptor) return $(Loader)

    return (
      $(Container,
        $(DetailsInfo, {
          ...this.props,
          descriptor,
          setAddMode: this.setAddMode,
          openBottomView: this.showBottomPanel,
        }),
        bottomView === 'match' && $(PanelContainer,
          $(MatchPanel, {
            type: 'face',
            matchType: 'match',
            descriptor,
            closePanel: () => this.showBottomPanel(false),
          }),
        ),
        bottomView === 'identify' && $(PanelContainer,
          $(MatchPanel, {
            descriptor,
            type: 'face',
            matchType: 'identify',
            closePanel: () => this.showBottomPanel(false),
          })
        ),
        bottomView === 'verify' && $(PanelContainer,
          $(VerifyPanel, {
            descriptor,
            closePanel: () => this.showBottomPanel(undefined),
          })
        ),
        addMode === 'lists' && $(AddListPanel, {
          type: 'faces',
          selected: descriptor.lists || [],
          onClose: () => this.setAddMode(),
          onSubmit: this.handleSubmitLists,
        }),
        addMode === 'persons' && $(AddPersonsPanel, {
          selected: descriptor.person ? [descriptor.person] : [],
          single: true,
          onClose: () => this.setAddMode(),
          onSubmit: this.handleSubmitPerson,
        }),
      )
    )
  }
}

export default withRouter(
  compose(
    graphql(AttachDescriptorToPerson, {name: 'attachDescriptorToPerson'}),
    graphql(AttachListToDescriptor, {name: 'attachListToDescriptor'}),
    graphql(DetachListFromDescriptor, {name: 'detachListFromDescriptor'}),
    graphql(DetachDescriptorFromPerson, {name: 'detachDescriptorFromPerson'}),
    graphql(DESCRIPTOR, {
      options: props => ({
        fetchPolicy: 'cache-and-network',
        variables: {
          uuid: props.match.params.id
        }
      })
    })
  )(withConsumer(DetailsPage, '/faces')))


// WEBPACK FOOTER //
// ./src/pages/Faces/DetailsPage.js